import { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { IconBottomBarManage, IconBottomBarSearch } from '../../../assets/icons'
import { PATH } from '../../../constants/router'
import useFixedBottomPadding from '../../../hooks/common/useFixedBottomPadding'
import './index.scss'

export default function BottomBar({
  elementPaddingBottom = 'app',
  tabActive = 1,
  searchPath = PATH.TRAFFIC_FINE_LOOKUP,
  managePath = PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT,
  onLookupClick,
  onRegistrationManagementClick,
  topContent
}) {
  const history = useHistory()
  const ref = useRef(null)

  useFixedBottomPadding(ref, elementPaddingBottom)

  return (
    <div className="BottomBar_wrapper" ref={ref}>
      {topContent ? <div className="BottomBar_topContent">{topContent}</div> : null}

      <div className="BottomBar">
        <div className="w-100 m-auto">
          <div
            className={`BottomBar_item ${tabActive === 1 ? 'BottomBar_item_active' : ''}`}
            onClick={() => {
              if (tabActive !== 1) {
                if (onLookupClick) {
                  onLookupClick()
                  return
                }

                history.push(searchPath)
              }
            }}>
            <div className="BottomBar_item_line"></div>
            <IconBottomBarSearch className="BottomBar_item_icon" />
            <div className="BottomBar_item_text">Tra cứu</div>
          </div>
        </div>

        <div className="w-100">
          <div
            className={`BottomBar_item ${tabActive === 2 ? 'BottomBar_item_active' : ''}`}
            onClick={() => {
              if (tabActive !== 2) {
                if (onRegistrationManagementClick) {
                  onRegistrationManagementClick()
                  return
                }

                history.push(managePath)
              }
            }}>
            <div className="BottomBar_item_line"></div>
            <IconBottomBarManage className="BottomBar_item_icon" />
            <div className="BottomBar_item_text">Quản lý đăng ký</div>
          </div>
        </div>
      </div>
    </div>
  )
}

